import ReconnectingWebSocket from 'reconnecting-websocket';
import { uuid } from '@/util';

// TO-DO:
// - solo atender a los mensajes de los aparcamientos relacionados con el operador logado

const MOSTRAR_TRAZAS = false;
// const MOSTRAR_TRAZAS = (process.env.NODE_ENV == "development");
const zlib = require('zlib');

class SAGAbroker {

  id_cliente = '';
  eventoConectado = null;

  rws = null;
  uuid_cliente = null;
  secuencia = 0;
  promesas_mensajes_esperando_respuesta = {};
  escuchadoresTemas = [];
  contadorManejadoresEscuchadoresTemas = 0;
  manejadorIntervalTestigo = null;

  // al establecer conexion con SAGABroker, nos suscribimos a los temas...
  eventoOpen = () => {
    let mensaje = {
      cabecera: {
        tipo: "INICIO_SESION",
      },
      contenido: {
        id: this.id_cliente,
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language
      }
    };
    this.enviarMensaje (mensaje);

    this.altaSuscripcionTemas (["cliente/" + this.uuid_cliente]);
    if (this.eventoConectado)
      this.eventoConectado (this);
  }

  // comprimir una cadena con zlib y devolver los datos binarios codificados en base64
  deflate (str) {
    let output = zlib.deflateSync(new Buffer.from(str, 'utf-8'));
    return output.toString('base64', 0, output.length);
  }

  // descomprimir con zlib datos binarios codificados en base64
  inflate (base64str) {
    let output = zlib.inflateSync (new Buffer(base64str, "base64"));
    return output.toString('utf-8', 0, output.length);
  }

  // gestor de mensajes de los temas a los que nos hemos suscrito
  eventoMessage = (trama) => {
    let mensaje = JSON.parse (trama.data);

    if (mensaje.contenido_comprimido) {
      mensaje.contenido = JSON.parse (this.inflate (mensaje.contenido_comprimido));
      delete mensaje.contenido_comprimido;
    }

    if (MOSTRAR_TRAZAS)
      console.log ('(R)', mensaje.cabecera.tipo, JSON.stringify (mensaje.cabecera), mensaje.contenido || '');

    // resolvemos una posible promesa que estuviera a la espera de respuesta
    if (mensaje.cabecera.respuesta_a_uuid_mensaje) {
      this.promesas_mensajes_esperando_respuesta [mensaje.cabecera.respuesta_a_uuid_mensaje].resolve (mensaje);
      delete (this.promesas_mensajes_esperando_respuesta [mensaje.cabecera.respuesta_a_uuid_mensaje]);
    }

    // notificamos a los escuchadores de temas
    this.notificarEscuchadoresTema (mensaje);
  }

  constructor (servidor_puerto, id_cliente, eventoConectado)  {
    servidor_puerto = servidor_puerto.replace ('http://', 'ws://');
    servidor_puerto = servidor_puerto.replace ('https://', 'wss://');

    if (MOSTRAR_TRAZAS)
      console.log ('Servidor SAGABroker: ', servidor_puerto);

    if (id_cliente)
      this.id_cliente = id_cliente;
    else
      this.id_cliente = 'ARIS';
    this.eventoConectado = eventoConectado;

    this.rws = new ReconnectingWebSocket (servidor_puerto + '/ws');
    this.uuid_cliente = uuid();

    // --- A L   C O N E C T A R ---
    this.rws.addEventListener ('open', this.eventoOpen);

    // --- R E C E P C I O N E S ---
    this.rws.addEventListener ('message', this.eventoMessage);

    // programamos un envio periodico de "testigo", para mantener viva la conexion
    this.manejadorIntervalTestigo = setInterval (() => {
      let mensaje = {
        cabecera: {
          tipo: "TESTIGO",
        }
      };
      this.enviarMensaje (mensaje);
    }, 30 * 1000);
  }

  finalizar () {
    clearInterval (this.manejadorIntervalTestigo);

    this.rws.removeEventListener ('message', this.eventoMessage);
    this.rws.removeEventListener ('open', this.eventoOpen);

    this.rws.close();
    this.rws = null;
  }

  // --- E N V I O S ---
  enviarMensaje (mensaje) {
    if (this.rws.readyState != this.rws.OPEN)
      return;

    //mensaje.cabecera.id_cliente = this.uuid_cliente;
    mensaje.cabecera.secuencia = ++this.secuencia;

    let trama = JSON.stringify (mensaje);
    this.rws.send (trama);

    if (MOSTRAR_TRAZAS)
      console.log ('(E)', mensaje.cabecera.tipo, JSON.stringify (mensaje.cabecera), mensaje.contenido || '');
  }

  // funcion para enviar una publicacion generica con posibilidad de indicar cuanto tiempo hay que esperar la respuesta
  publicar (tema, contenido, msTimeoutRespuesta = 0) {
    let resultado = null;
    let mensaje = {
      cabecera: {
        tipo: "PUBLICACION",
        tema: tema
      },
      contenido: contenido
    };

    if (msTimeoutRespuesta > 0) {
      let uuid_mensaje = uuid();
      mensaje.cabecera.tema_respuesta = "cliente/" + this.uuid_cliente;
      mensaje.cabecera.uuid_mensaje = uuid_mensaje;
      mensaje.cabecera.ms_tiempo_maximo_respuesta = msTimeoutRespuesta;
      resultado = new Promise ((resolve, reject) => {
        this.promesas_mensajes_esperando_respuesta [uuid_mensaje] = { resolve: resolve, reject: reject };
      });

      setTimeout(() => {
        if (this.promesas_mensajes_esperando_respuesta [uuid_mensaje] != undefined)
          this.promesas_mensajes_esperando_respuesta [uuid_mensaje].reject();
      }, msTimeoutRespuesta);
    }

    this.enviarMensaje (mensaje);

    return resultado;
  }

  // metodo para suscribirse a temas de SAGABroker
  altaSuscripcionTemas (array_temas) {
    if (!Array.isArray (array_temas))
      throw "El parámetro 'array_temas' debe ser de tipo array";

    let mensaje = {
      cabecera: {
        tipo: 'SUSCRIPCION',
        temas: array_temas,
      }
    };
    this.enviarMensaje (mensaje);
  }

  // metodo para suscribirse a temas de SAGABroker
  bajaSuscripcionTemas (array_temas) {
    if (!Array.isArray (array_temas))
      throw "El parámetro 'array_temas' debe ser de tipo array";

    let mensaje = {
      cabecera: {
        tipo: 'BAJA_SUSCRIPCION',
        temas: array_temas,
      }
    };
    this.enviarMensaje (mensaje);
  }

  //----------------------------------

  // metodo para enviar un mensaje para informar que una llamada ha sido atendida
  informarLlamadaAtendida (id_registro_interfonia) {
    return this.publicar ("central_interfonia/llamadas", {
        tipo_mensaje: "informar_llamada_atendida",
        id_registro_interfonia: id_registro_interfonia
      });
  }

  // metodo para enviar una orden a una aparato de un aparcamiento
  ejecutarAccionAparato (id_instalacion, operador, tipo_aparato, numero_aparato, accion, extra) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom/accion_aparato`, {
        tipo_mensaje: "accion_aparato",
        operador: operador,
        tipo_aparato: tipo_aparato,
        numero_aparato: numero_aparato,
        accion: accion,
        extra: extra
      });
  }

  // metodo para solicitar una actualizacion de estado completa
  solicitarActualizacionEstadoAparatos (id_instalacion) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom`, {
        tipo_mensaje: "actualizacion_estado_aparatos",
        tema_respuesta: "cliente/" + this.uuid_cliente
      });
  }

  // metodo para ajustar las plazas de una zona
  ajustarPlazasZona (id_instalacion, operador, codigo_zona, total_plazas, plazas_libres) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom`, {
        tipo_mensaje: "ajuste_plazas_zona",
        operador: operador,
        codigo_zona: codigo_zona,
        total_plazas: total_plazas,
        plazas_libres: plazas_libres
      });
  }

  // metodo para solicitar listado de ultimas operaciones de un cajero/día
  solicitarUltimasOperaciones (id_instalacion, numero_cajero, fecha) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom`, {
        tipo_mensaje: "peticion_ultimas_operaciones_cajero",
        numero_cajero: numero_cajero,
        fecha: fecha
      }, 4000);
  }

  // metodo para solicitar listado de ultimos cobros del aparcamiento
  solicitarUltimosCobrosAparcamiento (id_instalacion) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom`, {
        tipo_mensaje: "peticion_ultimos_cobros"
      }, 4000);
  }

  // metodo para solicitar listado de ultimos cobros del aparcamiento
  solicitarDatosGestionTicketPerdido (id_instalacion) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom`, {
        tipo_mensaje: "peticion_datos_gestion_ticket_perdido"
      }, 4000);
  }

  // metodo para solicitar listado de ultimos cobros del aparcamiento
  solicitarReciboCobro (id_instalacion, codigo_cobro) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom`, {
        tipo_mensaje: "peticion_recibo_cobro",
        codigo_cobro: codigo_cobro
      }, 4000);
  }

  solicitarListaTarifasAparcamiento (id_instalacion) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom`, {
      tipo_mensaje: "peticion_lista_tarifas"
    }, 4000);
  }

  // metodo para solicitar productos por numero o matricula
  solicitarProductosPorNumeroOMatricula (id_instalacion, busqueda, antiguedad_maxima) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom`, {
      tipo_mensaje: "buscar_productos_por_numero_o_matricula",
      busqueda: busqueda,
      antiguedad_maxima: antiguedad_maxima
    }, 4000);
  }

  // metodo para solicitar los datos de contexto de apertura manual
  solicitarDatosContextoAperturaManual (id_instalacion, tipo_aparato, numero_aparato) {
    return this.publicar (`aparcamiento/${id_instalacion}/sagacom`, {
        tipo_mensaje: "peticion_datos_contexto_apertura_manual",
        tipo_aparato: tipo_aparato,
        numero_aparato: numero_aparato
      }, 2000);
  }



  // --- NOTIFICACION DE MENSAJES ---

  anadirEscuchadorTema (suscripcion, funcion) {
    this.contadorManejadoresEscuchadoresTemas++;
    this.escuchadoresTemas.push ( { manejador: this.contadorManejadoresEscuchadoresTemas,
                                    suscripcion: suscripcion,
                                    funcion: funcion } );
    return this.contadorManejadoresEscuchadoresTemas;
  }

  eliminarEscuchadorTema (manejadorEscuchador) {
    this.escuchadoresTemas = this.escuchadoresTemas.filter (
      (elemento) => {
        if (elemento.manejador != manejadorEscuchador)
          return elemento;
      }
    )
  }

  listaTemasEnEscucha () {
    let aux = [];
    this.escuchadoresTemas.forEach ((e) => {
      aux.push (e.suscripcion);
    });
    return aux;
  }

  notificarEscuchadoresTema (mensaje) {

    function temaCoincideConSuscripcion (tema, suscripcion) {
      let partesTema = tema.split ("/");
      let partesSuscripcion = suscripcion.split ("/");

      if ((partesSuscripcion.length > 0) && (partesSuscripcion [partesSuscripcion.length-1] == "..."))
        while (partesSuscripcion.length < partesTema.length)
          partesSuscripcion.push ('...');

      if (partesSuscripcion.length != partesTema.length)
        return false;

      let coincidencias = 0;
      for (let i=0; i < partesSuscripcion.length; i++)
        if (['*', '...'].includes (partesSuscripcion[i]) ||
            partesSuscripcion[i].localeCompare (partesTema[i], undefined, { sensitivity: "accent" }) == 0)
          coincidencias++;

       return (coincidencias == partesTema.length);
    }

    this.escuchadoresTemas.forEach (
      (elemento) => {
        if (temaCoincideConSuscripcion (mensaje.cabecera.tema, elemento.suscripcion)) {
          if (elemento.funcion)
            elemento.funcion (mensaje);
        }
      }
    )
  }
}

export default SAGAbroker

/*

*********** Estructura de los mensajes: ***********

{
  "cabecera": {
    "tipo": "PUBLICACION",
    "tema": "...",
    "id_cliente": "...",
    "secuencia": 55,
    "tema_respuesta": "...",
    "tiempo_maximo_respuesta": 1
  },
  "contenido": {

  }
}

{
  "cabecera": {
    "tipo": "SUSCRIPCION|BAJA_SUSCRIPCION",
    "temas": ["...", "..."],
    "id_cliente": "...",
    "secuencia": 55
  }
}

{
  "cabecera": {
    "tipo": "TESTIGO",
    "id_cliente": "...",
    "secuencia": 55
  }
}

{
  "cabecera": {
    "tipo": "INICIO_SESION",
    "id_cliente": "...",
    "secuencia": 55,
    "clave": "..."
  },
  "contenido": {
    "informacion_cliente": {

	  }
  }
}

*/
